import ListItemButton from '@mui/material/ListItemButton'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'

const IconMenuButton = ({ menu_params, current_menu, Icono, small = false }) => {
  return (
    <ListItemButton
      key={current_menu.id}
      id={current_menu.id}
      {...menu_params}
      sx={{
        p: '4px',
        borderTopLeftRadius: '15px',
        borderBottomLeftRadius: '15px',
        pl: 2,
        pr: 1,
        fontWeight: '300',
      }}
    >
      <ListItemIcon sx={{ minWidth: small ? '36px' : '56px' }}>
        {Icono ? <Icono sx={{ color: 'background.menuContrast' }} /> : null}
      </ListItemIcon>
      {small ? '' : <ListItemText primary={current_menu.nombre} />}
    </ListItemButton>
  )
}

export default IconMenuButton
